import React from 'react';
import PropTypes from 'prop-types';
import {observer, inject} from 'mobx-react';
import {NewTabLink} from 'fn-common-ui';
import {utilsService} from '../../core/services/utils.service';
import EditDeleteButtons from '../edit-delete-buttons/edit-delete-buttons';

@inject('store')
@observer
export default class Media extends React.Component {

  static propTypes = {
    store: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    fileName: PropTypes.string,
    href: PropTypes.string,
    image: PropTypes.string,
    imageAltText: PropTypes.string,
    keywords: PropTypes.string,
    sectionId: PropTypes.number.isRequired,
    isInEditMode: PropTypes.bool
  }

  static defaultProps = {
    fileName: '',
    href: '',
    image: '',
    imageAltText: ''
  }

  constructor(props) {
    super(props);
    this.isExternalLink = Boolean(this.props.href);
    this.isFile = Boolean(this.props.fileName);
    this.isMalformed = !this.isExternalLink && !this.isFile;
    this.supportingImageSrc = utilsService.getFilePath(this.props.image);
    if(this.isFile) {
      this.fileSrc = utilsService.getFilePath(this.props.fileName);
    }
  }

  handleDocumentClick = () => {
    console.log('clicking document', this.props.title);
    let linkName = 'View Guide';
    let linkDestination = 'training.firstnet.att.com';

    if (!this.isFile) {
      if (this.props.title === 'User Management Help') {
        linkName = 'View Guides';
      } else {
        linkName = 'View Details';
      }
      linkDestination = this.props.href;
    }

    utilsService.tagLinkItem(this.props.title, linkName, linkDestination);
  }

  renderTitle = () => {
    if(this.isFile) {
      return (
        <NewTabLink
          id={utilsService.getFilename(this.props.fileName)}
          to={this.fileSrc}
          onClick={this.handleDocumentClick}
          className="as-h3 as-link click-tracked"
          hideIcon={true}>
          <h3 className="media-item-title">
            {this.props.title}
          </h3>
        </NewTabLink>
      )
    }

    return (
      <NewTabLink
        id={this.props.href}
        to={this.props.href}
        onClick={this.handleDocumentClick}
        className="click-tracked"
        hideIcon={true}>
        <h3 className="media-item-title">
          {this.props.title}
          {this.props.description.length === 0 && <i className="icon-external-site" aria-hidden="true" />}
        </h3>
      </NewTabLink>
    )
  }

  renderAction = () => {
    if(this.isFile) {
      return (
        <NewTabLink
          to={this.fileSrc}
          className="as-link"
          onClick={this.handleDocumentClick}
          hideIcon={true}>
          <span aria-label={`View ${this.props.title}`}>
            View Guide&nbsp;
            <i className="icon-arrowRight" aria-hidden="true" />
          </span>
        </NewTabLink>
      )
    }

    return (
      <NewTabLink
        to={this.props.href}
        onClick={this.handleDocumentClick}
        >
        <span aria-label={`View details for ${this.props.title}`}>
          { this.props.title==='User Management Help' ? 'View guides' : 'View Details' }
        </span>
      </NewTabLink>
    )
  }

  render() {
    if(this.isMalformed) {
      console.warn('Found a malformed media item. Skipping render.');
      return;
    }
    return (
      <React.Fragment>
        {this.props.isInEditMode && <EditDeleteButtons
          contentId={this.props.id}
          sectionId={this.props.sectionId}
          title={this.props.title}
          align="right" />}
        <div className="media-item">
            {this.props.image &&
              <div className="media-item__object col-12 col-sm-3">
                <img
                  className="img-fluid"
                  src={this.supportingImageSrc}
                  alt={this.props.imageAltText || 'Image for ' + this.props.title} />
              </div>
            }
            <div className={`media-item__body col-12 ${this.props.image ? 'col-sm-9' : 'col-sm-12'}`}>
              {this.renderTitle()}
              <p>{this.props.description}</p>
              <div className="media-item-button-link">
                {this.renderAction()}
              </div>
            </div>
        </div>
      </React.Fragment>
    )
  }
}
